// IdentificationStatusTag.jsx
import React from "react";
import { Tag } from "antd";
import { identityStatusConfig } from "../../../helper";
// MODIFIED: Import the new centralized config

export const IdentificationStatusTag = ({ status }) => {
  const config = identityStatusConfig[status];

  // Return null or a default tag if the status is unknown
  if (!config) {
    return null;
  }

  return (
    <div className="identification-status-tag">
      <Tag icon={config.ui.icon} color={config.ui.tagColor}>
        <span style={{ color: "#393b4a" }}>{status}</span>
      </Tag>
    </div>
  );
};
